import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { Location } from '@angular/common'
import { OmsService } from '../../services/oms.service';
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { OrdersService } from '../../services/orders.service';
import { Order } from '../../classes/orders';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as XLSX from 'xlsx';
import * as jQuery from 'jquery';
import { DashboardService } from 'app/services/dashboard.service';
import { concat, of, Subscription } from 'rxjs';
import { concatMap, tap, takeUntil } from 'rxjs/operators';
import { DashboardStatBucket } from '../../shared/dashboard-stat-card/dashboard-stat-card.component';
import { buildDashboardThemeVars } from '../../shared/dashboard-widget-theme';

@Component({
	selector: 'app-orders-dashboard',
	templateUrl: './orders-dashboard.component.html',
	styleUrls: ['./orders-dashboard.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		])
	]
})
export class OrdersDashboardComponent implements OnInit, OnDestroy {

	picking: any = [];
	adrs: any = [];
	flip = 'inactive';
	header: any;
	results: any;
	fliptitle: any;
	billable: any;
	viewing_title = '';
	viewing_data: any = false;
	picklatezero = [];
	picklateone = [];
	picklatetwo = [];
	picklatethree = [];

	notfillablezero = [];
	notfillableone = [];
	notfillabletwo = [];
	notfillablethree = [];
	/** Partially fillable — same age buckets as Fillable (DATE_ORDERED). */
	paritalzero = [];
	paritalone = [];
	paritaltwo = [];
	paritalthree = [];
	credits: any = [];

	allorders;
	allzero = [];
	allone = [];
	alltwo = [];
	allthree = [];
	returns = [];
	refused: any = [];
	notready: any;
	status: any;
	carddata: any;
	data: any;
	ready: any;


	fileName;
	public type: string;
	public error;
	color: any = 'blue'
	config: any = [];

	quotes: any = [];
	overdues: any = [];
	overdue1: any = [];
	overdue2: any = [];
	overdue3: any = [];
	notdue: any = [];

	overdues_length: any;
	overdue1_length: any;
	overdue2_length: any;
	overdue3_length: any;
	overdue_unique_length: any;
	notdue_length: any;
	flipdata: boolean | unknown[];

	private destroy$ = new Subject<void>();
	private subscriptions: Subscription[] = [];

	constructor(private dashboardService: DashboardService, private route: ActivatedRoute, private globalSearchService: GlobalSearchService, private ordersService: OrdersService, private omsService: OmsService, public cdr: ChangeDetectorRef, private location: Location, public router: Router, private formBuilder: UntypedFormBuilder) {
		this.color = this.globalSearchService.getColor();
		this.subscriptions.push(
			this.globalSearchService.configsubscription.pipe(takeUntil(this.destroy$)).subscribe(r => {
				this.config = r;
			})
		);

	}



	ngOnInit(): void {
		this.error = '';

		const token = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
		if (token) {
			this.omsService.setupSocketConnection(token);
			this.omsService.subscribeToCards((err, data) => {
				if (data) {
					this.loadData()
				}
			});
		}



		this.subscriptions.push(
			this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
				if (params['type']) {
					this.toggleFlip(params['type'], 'inactive')
				}
			})
		);


		this.loadData()
	}

	randomString(length, chars) {
		let result = '';
		for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
		return result;
	}

	consolidatePicks(input: any) {
		const orders = [];
		return input.map((ord) => {
			if (ord.ORDER_NUMBER && ord.DATE_ORDERED && !orders.includes(ord.ORDER_NUMBER) && ord.CUST_NAME) {
				orders.push(ord.ORDER_NUMBER)
				return ord;
			}
		}).filter((res) => res != undefined)
	}

	pickLoading: any = false;
	loadData() {

		const LATE_FILTER_CONFIG = {
			allzero: { fromdays: 3, todays: 0 },
			allone: { fromdays: 5, todays: 3 },
			alltwo: { fromdays: 7, todays: 5 },
			allthree: { fromdays: 9999, todays: 7 },
			billable: { fromdays: 5, todays: 3 },
			notfillablezero: { fromdays: 3, todays: 0 },
			notfillableone: { fromdays: 5, todays: 3 },
			notfillabletwo: { fromdays: 7, todays: 5 },
			notfillablethree: { fromdays: 9999, todays: 7 },
			picklatezero: { fromdays: 3, todays: 0 },
			picklateone: { fromdays: 5, todays: 3 },
			picklatetwo: { fromdays: 7, todays: 5 },
			picklatethree: { fromdays: 90, todays: 7 }, // Forced
		};


		this.subscriptions.push(
			concat(
			  this.ordersService.getPicking().pipe(tap(results => {
					this.picking = results;
					this.globalSearchService.pickingOrderData.next(results);
			  })),
			  this.ordersService.getRefused().pipe(tap(results => {
					this.refused = results;
			  })),
			  this.ordersService.getADRSCount().pipe(tap(results => {
					this.adrs = results;
			  })),
			  this.ordersService.getOpenQuotes().pipe(tap(results => {
					this.quotes = results;
			  }))
			).pipe(takeUntil(this.destroy$)).subscribe()
		);

		this.pickLoading = true;
		this.subscriptions.push(
			this.globalSearchService.pickingOrderData.pipe(takeUntil(this.destroy$)).subscribe((results: any) => {
				this.picking = results;
				this.pickLoading = false;
				this.credits = Array.isArray(results?.opencredits) ? results.opencredits : [];
				if (this.picking) {
					this.allorders = this.consolidatePicks([...this.picking.notfillable, ...this.picking.fillable, ...this.picking.parital, ...this.picking.partialpicked, ...this.picking.picked]);
					this.picking.partialpicked = this.consolidatePicks(this.picking.partialpicked);
					this.picking.fillable = this.consolidatePicks(this.picking.fillable || []);
					this.picking.notfillable = this.consolidatePicks(this.picking.notfillable);
					this.picking.parital = this.consolidatePicks(this.picking.parital || []);

					this.picking.totalcount = this.allorders.length;
					this.picking.notfillablecount = this.picking.notfillable.length;

					const c = LATE_FILTER_CONFIG;

					this.allzero = this.getFilteredLates(this.allorders, c.allzero.fromdays, c.allzero.todays);
					this.allone = this.getFilteredLates(this.allorders, c.allone.fromdays, c.allone.todays);
					this.alltwo = this.getFilteredLates(this.allorders, c.alltwo.fromdays, c.alltwo.todays);
					this.allthree = this.getFilteredLates(this.allorders, c.allthree.fromdays, c.allthree.todays);


					this.billable = this.getFilteredLates(this.picking.billable, c.billable.fromdays, c.billable.todays);

					this.notfillablezero = this.getFilteredLates(this.picking.notfillable, c.notfillablezero.fromdays, c.notfillablezero.todays);
					this.notfillableone = this.getFilteredLates(this.picking.notfillable, c.notfillableone.fromdays, c.notfillableone.todays);
					this.notfillabletwo = this.getFilteredLates(this.picking.notfillable, c.notfillabletwo.fromdays, c.notfillabletwo.todays);
					this.notfillablethree = this.getFilteredLates(this.picking.notfillable, c.notfillablethree.fromdays, c.notfillablethree.todays);

					this.picklatezero = this.getFilteredLates(this.picking.fillable, c.picklatezero.fromdays, c.picklatezero.todays);
					this.picklateone = this.getFilteredLates(this.picking.fillable, c.picklateone.fromdays, c.picklateone.todays);
					this.picklatetwo = this.getFilteredLates(this.picking.fillable, c.picklatetwo.fromdays, c.picklatetwo.todays);
					this.picklatethree = this.getFilteredLatesForced(this.picking.fillable, c.picklatethree.fromdays, c.picklatethree.todays);

					this.paritalzero = this.getFilteredLates(this.picking.parital, c.picklatezero.fromdays, c.picklatezero.todays);
					this.paritalone = this.getFilteredLates(this.picking.parital, c.picklateone.fromdays, c.picklateone.todays);
					this.paritaltwo = this.getFilteredLates(this.picking.parital, c.picklatetwo.fromdays, c.picklatetwo.todays);
					this.paritalthree = this.getFilteredLatesForced(this.picking.parital, c.picklatethree.fromdays, c.picklatethree.todays);

					this.returns = this.getReturns(this.picking.fillable);


					this.overdues = this.getOverdues(this.allorders);
					this.overdue1 = this.getOverdues(this.allorders, 1, 5);
					this.overdue2 = this.getOverdues(this.allorders, 5, 10);
					this.overdue3 = this.getOverdues(this.allorders, 10, 9999);

					this.overdue_unique_length = [...new Set(this.overdues)].filter(Boolean).length;

				}
			})
		);
	}

	getReturns(datalist: any) {

		const result = datalist.filter((item: any) => {
			return (item.PICK < 0);

		});

		return result;

	}

	getFilteredLatesForced(datalist, fromdays: number, todays: number) {

		const result = datalist.filter((item: any) => {

			const subject = new Date(item.DATE_ORDERED);
			subject.setDate(subject.getDate());

			const before = new Date('1999-01-01');
			before.setDate(before.getDate());

			const until = new Date();
			until.setDate(until.getDate() - todays);
			return (subject >= before && subject <= until);

		});

		return result;

	}

	getFilteredLates(datalist, fromdays: number, todays: number) {

		const result = datalist.filter((item: any) => {
			const subject = new Date(item.DATE_ORDERED);

			subject.setDate(subject.getDate());

			const before = new Date();
			before.setDate(before.getDate() - fromdays);

			const until = new Date();
			until.setDate(until.getDate() - todays);

			return (subject >= before && subject <= until);

		});

		return result;

	}


	isNotDue(item){
		if(this.notdue.length){
			const match = this.notdue.filter((o) => { return o.ORDER_NUMBER == item.ORDER_NUMBER});
			if(!match.length){
				this.notdue.push(item);
			}
		}else{
			this.notdue.push(item);
		}
	}


	getOverdues(datalist: any[], fromdays?: number, todays?: number) {
		const now = new Date();
		now.setHours(0, 0, 0, 0); // truncate time

		const result = datalist.filter((item: any) => {
			const rawDate = item.DATE_WANTED || item.DATE_ORDERED;
			if (!rawDate) {return false;}

			const wanted = new Date(rawDate);
			wanted.setHours(0, 0, 0, 0); // truncate time

			const daysOverdue = Math.ceil((now.getTime() - wanted.getTime()) / (1000 * 3600 * 24));

			if (daysOverdue <= 0) {
				this.isNotDue(item);
				return false;
			}

			if (typeof fromdays === 'number' && typeof todays === 'number') {
				return daysOverdue >= fromdays && daysOverdue <= todays;
			}

			// fallback: all overdue
			return daysOverdue >= 1;
		});

		const countUnique = new Set(result.map(i => i.ORDER_NUMBER)).size;

		switch (todays) {
		case 5:
			this.overdue1_length = countUnique;
			break;
		case 10:
			this.overdue2_length = countUnique;
			break;
		case 9999:
			this.overdue3_length = countUnique;
			break;
		default:
			this.overdues_length = countUnique;
			break;
		}

		const sorted = result.sort((a, b) => {
			const aDate = new Date(a.DATE_WANTED || a.DATE_ORDERED);
			const bDate = new Date(b.DATE_WANTED || b.DATE_ORDERED);
			return aDate.getTime() - bDate.getTime();
		});

		return sorted;
	}


	addDays(date: Date, days: number): Date {
		date.setDate(date.getDate() + days);
		return date;
	}

	getHeader() {
		return this.header
	}

	getData() {
		return this.results
	}

	toggleFlipTest(viewing: any) {

		this.viewing_data = viewing.data
		this.viewing_title = viewing.title
		//this.flip = (this.flip == 'active') ? 'inactive':'active';
	}

	get flipThemeVars(): Record<string, string> {
		return buildDashboardThemeVars('cw', 'primary');
	}

	get pickingReady(): boolean {
		return !!this.picking;
	}

	get fillableCount(): number {
		if (!this.picklateone || !this.picklatetwo || !this.picklatethree) {
			return null;
		}
		return this.picklatezero.length + this.picklateone.length + this.picklatetwo.length + this.picklatethree.length;
	}

	get partialFillableCount(): number {
		if (!this.picking || !this.paritalone || !this.paritaltwo || !this.paritalthree) {
			return null;
		}
		return this.paritalzero.length + this.paritalone.length + this.paritaltwo.length + this.paritalthree.length;
	}

	get notFillableCount(): number {
		return this.picking?.notfillablecount ?? null;
	}

	get openOrdersBuckets(): DashboardStatBucket[] {
		if (!this.picking) {
			return [];
		}
		const buckets: DashboardStatBucket[] = [
			{ key: 'allzero', label: '< 3 Days', count: this.allzero.length },
			{ key: 'allone', label: '3-5 Days', count: this.allone.length },
			{ key: 'alltwo', label: '5-7 Days', count: this.alltwo.length },
			{ key: 'allthree', label: '> 7 Days', count: this.allthree.length },
		];
		if (this.notdue?.length) {
			buckets.push({ key: 'notdue', label: 'Not Due', count: this.notdue.length });
		}
		return buckets;
	}

	get fillableBuckets(): DashboardStatBucket[] {
		if (!this.picking) {
			return [];
		}
		return [
			{ key: 'latezero', label: '< 3 Days', count: this.picklatezero.length },
			{ key: 'lateone', label: '3-5 Days', count: this.picklateone.length },
			{ key: 'latetwo', label: '5-7 Days', count: this.picklatetwo.length },
			{ key: 'late', label: '> 7 Days', count: this.picklatethree.length },
		];
	}

	get partialFillableBuckets(): DashboardStatBucket[] {
		if (!this.picking) {
			return [];
		}
		return [
			{ key: 'paritalzero', label: '< 3 Days', count: this.paritalzero.length },
			{ key: 'paritalone', label: '3-5 Days', count: this.paritalone.length },
			{ key: 'paritaltwo', label: '5-7 Days', count: this.paritaltwo.length },
			{ key: 'paritalthree', label: '> 7 Days', count: this.paritalthree.length },
		];
	}

	get notFillableBuckets(): DashboardStatBucket[] {
		if (!this.picking) {
			return [];
		}
		return [
			{ key: 'notfillablezero', label: '< 3 Days', count: this.notfillablezero.length },
			{ key: 'notfillableone', label: '3-5 Days', count: this.notfillableone.length },
			{ key: 'notfillabletwo', label: '5-7 Days', count: this.notfillabletwo.length },
			{ key: 'notfillablethree', label: '> 7 Days', count: this.notfillablethree.length },
		];
	}

	get overdueBuckets(): DashboardStatBucket[] {
		if (!this.overdues) {
			return [];
		}
		return [
			{ key: 'overdue1', label: '1-5 Days', count: this.overdue1_length ?? 0 },
			{ key: 'overdue2', label: '5-10 Days', count: this.overdue2_length ?? 0 },
			{ key: 'overdue3', label: '> 10 Days', count: this.overdue3_length ?? 0 },
		];
	}

	onStatBucket(bucket: DashboardStatBucket): void {
		const forcedData: Record<string, any[]> = {
			allzero: this.allzero,
			allone: this.allone,
			alltwo: this.alltwo,
			allthree: this.allthree,
			notdue: this.notdue,
			notfillablezero: this.notfillablezero,
			notfillableone: this.notfillableone,
			notfillabletwo: this.notfillabletwo,
			notfillablethree: this.notfillablethree,
			latezero: this.picklatezero,
			lateone: this.picklateone,
			latetwo: this.picklatetwo,
			late: this.picklatethree,
			overdue1: this.overdue1,
			overdue2: this.overdue2,
			overdue3: this.overdue3,
		};
		const key = bucket.key;
		if (key && forcedData[key]) {
			this.toggleFlip(key, '', true, forcedData[key]);
			return;
		}
		if (key) {
			this.toggleFlip(key, '');
		}
	}

	openCredits(): void {
		this.router.navigateByUrl('/credits/open-credits');
	}

	getOrderNumbers(input: any) {
		return [...new Set(input.map((ord: any) => {
			if (ord.ORDER_NUMBER) {
				return ord.ORDER_NUMBER
			}
		}))].filter(i => i !== undefined);
	}


	toggleFlip(dataset, setvalue, forcedata = false, list = []) {
		if (setvalue != '') {
			this.flip = setvalue;
		}
		///this is a bad idea. needs fixed
		switch (dataset) {
		case 'na':
			break;
		case 'refused':
			this.fliptitle = 'Refused Delivery';
			this.data = this.refused
			break;
		case 'quotes':
			this.fliptitle = 'Open Quotes';
			this.data = this.quotes
			break;
		case 'billable':
			this.fliptitle = 'Needs Invoices';

			this.data = this.picking.billable
			this.type = 'billable';
			break;
		case 'inpick':
			this.fliptitle = 'In Route Builder';
			this.data = this.picking.inpick
			this.type = 'inpick';
			break;
		case 'snoozed':
			this.fliptitle = 'Snoozed';
			this.type = 'snoozed';
			this.data = this.picking.snoozed
			break;
		case 'returns':
			this.fliptitle = 'Return to Bin';
			this.type = 'returns';
			this.data = this.returns
			this.flipdata = false;

			break;
		case 'notfillablethree':
			this.fliptitle = '7+ Not Fillable Orders';
			this.type = 'notfillablethree';
			this.data = this.notfillablethree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'notfillabletwo':
			this.fliptitle = '5-7 Not Fillable Orders';
			this.type = 'notfillabletwo';
			this.data = this.notfillabletwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'notfillablezero':
			this.fliptitle = '< 3 Day Not Fillable Orders';
			this.type = 'notfillablezero';
			this.data = this.notfillablezero;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'notfillableone':
			this.fliptitle = '3+ Not Fillable Orders';
			this.type = 'notfillableone';
			this.data = this.notfillableone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'allthree':
			this.fliptitle = 'All 7+ Orders';
			this.type = 'allthree';
			this.data = this.allthree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'alltwo':
			this.fliptitle = 'All 5-7 Orders';
			this.type = 'alltwo';
			this.data = this.alltwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'allzero':
			this.fliptitle = 'All < 3 Day Orders';
			this.type = 'allzero';
			this.data = this.allzero;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'allone':
			this.fliptitle = 'All 3-5 Orders';
			this.type = 'allone';
			this.data = this.allone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'late':
			this.fliptitle = '7+ Late Orders';
			this.type = 'late';
			this.data = this.picklatethree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'notdue':
			this.fliptitle = 'Not Due Orders';
			this.type = 'notdue';
			this.data = this.notdue;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'adrs':
			this.router.navigateByUrl('orders/adrs');
			break;
		case 'latezero':
			this.fliptitle = '< 3 Day Fillable Orders';
			this.type = 'latezero';
			this.data = this.picklatezero;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'lateone':
			this.fliptitle = '3-5 Orders';
			this.type = 'latetwo';
			this.data = this.picklateone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'latetwo':
			this.fliptitle = '5-7 Orders';
			this.type = 'latetwo';
			this.data = this.picklatetwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'partialpicked':
			this.fliptitle = 'Parital Picks';
			this.type = 'partialpicked';
			this.data = this.picking.partialpicked;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'dispatched':
			this.fliptitle = 'Dispatched';
			this.type = 'dispatched';
			this.data = this.picking.dispatched;
			break;
		case 'picked':
			this.fliptitle = 'Picked Orders';
			this.type = 'picked';
			this.data = this.picking.picked;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'parital':
			this.fliptitle = 'Partially Fillable Orders';
			this.type = 'parital';
			this.data = this.picking.parital;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'paritalzero':
			this.fliptitle = '< 3 Days Partially Fillable';
			this.type = 'paritalzero';
			this.data = this.paritalzero;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'paritalone':
			this.fliptitle = '3-5 Days Partially Fillable';
			this.type = 'paritalone';
			this.data = this.paritalone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'paritaltwo':
			this.fliptitle = '5-7 Days Partially Fillable';
			this.type = 'paritaltwo';
			this.data = this.paritaltwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'paritalthree':
			this.fliptitle = '7+ Days Partially Fillable';
			this.type = 'paritalthree';
			this.data = this.paritalthree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'notfillablecount':
			this.fliptitle = 'Non Fillable Orders';
			this.type = 'notfillablecount';
			this.data = this.picking.notfillable;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'fillable':
			this.fliptitle = 'Fillable Orders';
			this.type = 'fillable';
			this.data = this.picking.fillable;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'credits':
			this.fliptitle = 'Open Credits';
			this.type = 'credits';
			this.data = this.credits;
			break;
		case 'openorders':
			this.fliptitle = 'Open Orders';
			this.type = 'openorders';
			this.data = [...this.picking.notfillable, ...this.picking.fillable, ...this.picking.partialpicked];
			this.flipdata = false;
			break;
		case 'overdues':
			this.fliptitle = 'All Overdue Orders';
			this.type = 'overdues';
			this.data = this.overdues;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'overdue1':
			this.fliptitle = '1-5 Overdue Orders';
			this.type = 'overdue1';
			this.data = this.overdue1;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'overdue2':
			this.fliptitle = '5-10 Overdue Orders';
			this.type = 'overdue2';
			this.data = this.overdue2;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'overdue3':
			this.fliptitle = '>10 Overdue Orders';
			this.type = 'overdue3';
			this.data = this.overdue3;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		default:
			this.fliptitle = dataset;

			if (forcedata) {
				this.data = list;
			} else {
				this.data = this.picking[dataset];
			}

			this.type = 'late';

			break;
		}
		switch (this.flip) {
		case 'inactive':
			this.flip = 'active';
			this.parseData(this.data);
			//this.updateData();
			//this.focusInput();
			break;
		default:

			this.flip = 'inactive';
			break;
		}

	}

	selectItemLookup(event: any) {
		this.router.navigate(['./orders/entry/' + event.header.debtorno + '/' + event.header.branchcode]);
		//http://localhost:4200/#/orders/entry/107/00
	}

	invoiceOrder(event: any) {
		this.router.navigate(['orders/invoice/' + event + '/dispatch']);
	}

	parseData(listin) {
		const newheader = [];
		(Object.keys(Object.values(listin)[0])).forEach((keys: any, vals: any) => {
			if (keys) {
				if (keys != 'sort') {
					newheader.push({ title: keys, data: keys })
				}
			}
		});
		const newvalues = []
		listin.forEach((keys: any, vals: any) => {
			newvalues.push(keys);
		});



		this.header = newheader;
		this.results = newvalues;

	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(sub => {
			if (sub && !sub.closed) {
				sub.unsubscribe();
			}
		});
		this.subscriptions = [];
		if (this.omsService && this.omsService.disconnectOnly) {
			this.omsService.disconnectOnly();
		}
		this.destroy$.next();
		this.destroy$.complete();
	}

	back(): void {
		this.location.back()
	}

	focusInput() {

	}

	exportExcel(): void {
		/* table id is passed over here */
		const element = document.getElementById('excel-table');
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

		/* generate workbook and add the worksheet */
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		/* save to file */
		XLSX.writeFile(wb, this.fileName);

	}
}